/**
 * Server-side media validation results — ARCHITECTURE.md §13, §20, §22.
 * Every value here is recomputed server-side; client-declared metadata is never trusted.
 */
export const MEDIA_REJECTION_CODES = [
    'NO_VIDEO_STREAM',
    'MULTIPLE_VIDEO_STREAMS',
    'CONTAINER_UNPARSEABLE',
    'FILE_CORRUPTED',
    'RESOLUTION_UNSUPPORTED',
    'ASPECT_RATIO_INVALID',
    'FPS_OUT_OF_SLA',
    'DURATION_OUT_OF_RANGE',
    'HASH_MISMATCH',
    'FILE_TOO_LARGE',
    'BEST_FRAME_NOT_FOUND',
    'SHARPNESS_BELOW_THRESHOLD',
    'EXPOSURE_OUT_OF_RANGE',
    'CONTRAST_BELOW_THRESHOLD',
    'GLARE_ABOVE_THRESHOLD',
    'VARIABLE_FRAME_TIMING',
    'PASSING_FRAME_RATIO_BELOW_MIN',
    'SUSTAINED_BAD_INTERVAL',
    'PROCESSING_FAILED',
];
/** §19 — best-frame search window around each client-suggested timestamp. */
export const BEST_FRAME_SEARCH_WINDOW_MS = 300;
/** §19 — client sends its top passing timestamps in the upload manifest. */
export const MAX_CLIENT_BEST_FRAME_HINTS = 5;
//# sourceMappingURL=media-validation.js.map